export default "__VITE_ASSET__BXt$Rqwm__";